import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import './assets/styles.css'

const app = createApp(App)

app.use(i18n)

// v-reveal: fade/slide elements into view on scroll using IntersectionObserver.
// Usage: <div v-reveal> or <div v-reveal="120"> (delay in ms)
app.directive('reveal', {
  mounted(el, binding) {
    el.classList.add('ec-reveal')
    if (binding.value) el.style.transitionDelay = `${binding.value}ms`

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-visible')
      return
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          obs.unobserve(entry.target)
        }
      })
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })

    observer.observe(el)
    el._revealObserver = observer
  },
  unmounted(el) {
    if (el._revealObserver) el._revealObserver.disconnect()
  }
})

app.mount('#app')
